import {
  isOrganizationOneascent,
  isOrganizationRivershares,
} from "../../../../../../../utils/helper/specialized";

export const getRecommendedProductId = ({
  organization,
  productsList,
  proposalData,
}) => {
  if (isOrganizationOneascent(organization)) {
    let productsNames = [];

    if (proposalData?.investmentAmount <= 499999) {
      productsNames = [
        "OneAscent Peak Equity Core",
        "OneAscent Peak Growth Core",
        "OneAscent Peak Moderate Core",
        "OneAscent Peak Conservative Core",
        "OneAscent Peak Preservation Core",
      ];
    } else {
      productsNames = [
        "OneAscent Peak Equity Elite",
        "OneAscent Peak Growth Elite",
        "OneAscent Peak Moderate Elite",
        "OneAscent Peak Conservative Elite",
        "OneAscent Peak Preservation Elite",
      ];
    }

    const recommendedProductName = productsNames.find(it =>
      it.toLowerCase().includes(proposalData?.riskTolerance?.toLowerCase())
    );

    return productsList.find(it => it.name === recommendedProductName)?._id;
  } else if (isOrganizationRivershares(organization)) {
    return productsList.find(
      it => it.riskTolerance === proposalData?.riskTolerance
    )?._id;
  } else {
    const riskTolerance = proposalData?.riskTolerance?.toLowerCase();

    if (riskTolerance === "growth") return 71;
    else if (riskTolerance === "preservation") return 72;
    else if (riskTolerance === "conservative") return 73;
    else if (riskTolerance === "moderate") return 74;
    else if (riskTolerance === "aggressive") return 75;
  }
};
